// eslint-disable-next-line import/no-unresolved
module.exports = require('./dist/lib/tree-utils');
